var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.75C21 10.1424 20.4469 11.4777 19.4623 12.4623C18.4777 13.4469 17.1424 14 15.75 14C14.3576 14 13.0223 13.4469 12.0377 12.4623C11.0531 11.4777 10.5 10.1424 10.5 8.75C10.5 7.35761 11.0531 6.02225 12.0377 5.03769C13.0223 4.05312 14.3576 3.5 15.75 3.5C17.1424 3.5 18.4777 4.05312 19.4623 5.03769C20.4469 6.02225 21 7.35761 21 8.75Z",
    fill: "#C0C3C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7V42C0 43.8565 0.737498 45.637 2.05025 46.9497C3.36301 48.2625 5.14348 49 7 49H49C50.8565 49 52.637 48.2625 53.9497 46.9497C55.2625 45.637 56 43.8565 56 42V7C56 5.14348 55.2625 3.36301 53.9497 2.05025C52.637 0.737498 50.8565 0 49 0H7ZM49 3.5C49.9283 3.5 50.8185 3.86875 51.4749 4.52513C52.1312 5.1815 52.5 6.07174 52.5 7V29.75L39.2805 22.9355C38.9523 22.7711 38.5807 22.714 38.2182 22.7725C37.8558 22.8309 37.5209 23.0018 37.261 23.261L24.276 36.246L14.966 30.044C14.6299 29.8202 14.2267 29.7196 13.8248 29.7591C13.4229 29.7987 13.0471 29.976 12.761 30.261L3.5 38.5V7C3.5 6.07174 3.86875 5.1815 4.52513 4.52513C5.1815 3.86875 6.07174 3.5 7 3.5H49Z",
    fill: "#C0C3C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.e2b469b27594dd4f68666043acdbbc19.svg";
export { ForwardRef as ReactComponent };